import { writable } from 'svelte/store';

function DocumentShadowRoot() {


	const { subscribe, update } = writable(document.body);
	
	const DocumentShadowRoot = {
        subscribe: subscribe,
        update: function(node){
            if(node === document){
                node = document.body;
            }
            update(( data )=>{
                data = node;
                return data;
            })
        },
    }

    return DocumentShadowRoot;
}


export const ShadowRoot = DocumentShadowRoot();